'use client';

import { useRef, useState, useEffect } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Stars } from '@react-three/drei';

const AnimatedSphere = () => {
    const meshRef = useRef<any>(null);
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const handleResize = () => {
            setScale(window.innerWidth < 1024 ? 0.6 : 1);
        };
        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useFrame((state, delta) => {
        if (meshRef.current) {
            meshRef.current.rotation.y += delta * 0.05;
            meshRef.current.rotation.x += delta * 0.02;
        }
    });

    return (
        <mesh ref={meshRef} scale={[scale, scale, scale]}>
            <sphereGeometry args={[3, 32, 32]} />
            <meshStandardMaterial
                color="#4f46e5"
                wireframe
                transparent
                opacity={0.2}
            />
        </mesh>
    );
};

const Scene = () => {
    return (
        <div className="absolute inset-0 w-full h-full" style={{ zIndex: 0 }}>
            <Canvas
                camera={{ position: [0, 0, 5], fov: 75 }}
                style={{ background: 'transparent' }}
                dpr={[1, 1.5]} // Cap pixel ratio for mobile performance
                gl={{ antialias: false, powerPreference: "high-performance" }} // Disable AA for performance
            >
                {/* Ambient lighting */}
                <ambientLight intensity={0.5} />

                {/* Point lights for depth */}
                <pointLight position={[10, 10, 10]} intensity={1} color="#6366f1" />
                <pointLight position={[-10, -10, -10]} intensity={0.5} color="#3b82f6" />

                {/* Optimized star field */}
                <Stars
                    radius={50}
                    depth={50}
                    count={1500}
                    factor={4}
                    saturation={0}
                    fade
                    speed={0.5}
                />

                <AnimatedSphere />
            </Canvas>
        </div>
    );
};

export default Scene;
